export default __webpack_public_path__ + "static/media/icon-sun.9422c153.svg";